import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Type } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { Branch, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { AccountService, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { RoundingType, Currency, ShippingCostReducedKind, TypeOfDocument, InvDailyBalanceInhibitorEnum } from "../branch.enum";
import { take, takeUntil } from "rxjs/operators";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BranchDataTransferInfo } from "projects/sepidz-web-framework/src/lib/models/branch.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { BranchDataTransferInfoComponent } from "../branch-data-transfer-info/branch-data-transfer-info.component";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { SplashFormService } from "../../../../../projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { SplashScreenService } from "../../../../../projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { PaymentMethodLookUp } from "../../../frontoffice/order/model/payment.lookup";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { Subject } from "rxjs";
import { MapComponent, MapConfirmValue } from "src/app/frontoffice/parties/map/map.component";
import { PaymentMethodType } from "src/app/frontoffice/financial/model/payment-method.enum";
import { EnumModel } from "src/app/frontoffice/order/orderpage/item/deposit/deposit.component";
import { SaleMethodBranchModel } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "ngx-branch-form",
  templateUrl: "./branch-form.component.html",
  styleUrls: ["./branch-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BranchFormComponent extends BaseFormComponent<Branch> {
  roundingType = RoundingType;
  shippingCostReducedKind = ShippingCostReducedKind;
  BranchDataTransferInfos: form_control[];
  currency = Currency;
  activeTabTitle: string;
  hasLocal: boolean = false;
  hasFleetService: boolean = false;
  SoftWareLicenseKind = SoftWareLicenseKind;
  deactivateSave: boolean = false;
  isAccounting: boolean;
  hasAccounting: boolean;
  SendingSalesType: boolean;
  TransferDebtorsType: boolean;
  isAccessToAllBranches = false;
  SendingSalesTypes = [
    { Id: "1", Name: "SaleMethodBranch", Title: this.translate("ClientApp.GNR.Branch.SaleMethod") },
    { Id: "2", Name: "ItemCategory", Title: this.translate("ClientApp.GNR.Branch.ItemCategory") },
    { Id: "3", Name: "Item", Title: this.translate("ClientApp.GNR.Branch.Item") },
  ];
  hasOrderOnline: boolean = false;
  public inputEditorform: Type<any>;
  public isSepidzUser: boolean;
  transferDebtorTypesData: any[];
  SendingSalesTypesData: any[];
  PaymentTypeData: PaymentMethodLookUp[];
  AggregateAndSeparateData: any[] = [];
  InvDailyBalanceInhibitorEnumDataList: EnumModel[];
  InvWarehouseDataList: any[] = [];
  isAccessToActivation = false;
  currentInformation = this.accountService.authService.currentInformation();

  constructor(
    public commonservice: CommonService,
    private lookupservice: LookupService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public splashScreenService: SplashScreenService,
    public splashFormService: SplashFormService,
    _tabsservice: TabularService,
    account: AccountService,
    public http: HttpClient
  ) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
    this.isAccounting =
      account.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
      account.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
      account.authService.currentInformation().AccountingKind === SoftWareLicenseKind.AccountingWeb;
    this.isSepidzUser = account.getCurrentUser().UserName === "SepidzUser" ? true : false;
    this.FillData();
  }
  async ngOnInit() {
    this.apiName = "Branch";
    this.label = this.translate("ClientApp.GNR.Branch.Branch");
    this.InvDailyBalanceInhibitorEnumDataList = this.enumToEnumModelArray(InvDailyBalanceInhibitorEnum);
    super.ngOnInit();
    this.addControl();
  }
  async FillData() {
    this.httpCommonService
      .getList("PaymentMethod/PaymentMethodLookUp" + "/" + (this.currentrow.Id || this.accountService.authService.currentBranchId))
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: PaymentMethodLookUp[]) => {
        const result = data.filter((x) => x.PaymentMethodCode == PaymentMethodType.Internet);
        this.PaymentTypeData = result;
      });

    this.httpCommonService
      .getList("Warehouse/HalfMadeWarehouseReadLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: PaymentMethodLookUp[]) => {
        this.InvWarehouseDataList = data;
        this.getSaleMethodBranchOnlineOrder();
      });

    if (!this.model.TimeForChange) this.model.TimeForChange = 2;
    if (!this.model.RoundingTypeId) {
      this.lookupservice
        .getLookupbyCode("GNR", "RoundingType", this.roundingType.Standard)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (x) => {
          this.model.RoundingTypeId = x.Id;
          this.model.RoundingTypeCode = x.Code;
          this.model.RoundingTypeTitle = x.Title;
        });
      if (!this.model.ShippingCostReducedKindId) {
        this.lookupservice
          .getLookupbyCode("GNR", "ShippingCostReducedKind", this.shippingCostReducedKind.NoReduced)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(async (x) => {
            this.model.ShippingCostReducedKindId = x.Id;
            this.model.ShippingCostReducedKindCode = x.Code;
            this.model.ShippingCostReducedKindTitle = x.Title;
          });
      }

      if (!this.model.TransferDebtorsTypeId) {
        this.lookupservice
          .getLookupbyCode("ACC", "TransferDebtorsType", TypeOfDocument.Separation)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(async (x) => {
            this.model.TransferDebtorsTypeId = x.Id;
            this.model.TransferDebtorsTypeCode = x.Code;
            this.model.TransferDebtorsTypeTitle = x.Title;
          });
      }
      if (!this.model.SendingSalesTypeId) {
        this.lookupservice
          .getLookupbyCode("ACC", "SendingSalesType", TypeOfDocument.Separation)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(async (x) => {
            this.model.SendingSalesTypeId = x.Id;
            this.model.SendingSalesTypeCode = x.Code;
            this.model.SendingSalesTypeTitle = x.Title;
          });
      }
    }
    const currentBranch = this.accountService.authService.currentInformation();
    if (currentBranch.BranchingLightEnabled || currentBranch.BranchingAdvancedEnabled || currentBranch.RestaurantCallCenter) {
      if (!this.accountService.authService.currentBranch.AccessToAllBranches) {
        this.sts.showDialog(this.translate("ClientApp.GNR.Branch.YouDoNotHaveAccessToThisArea"), this.translate("ClientApp.GNR.Branch.Attention"));
        this.deactivateSave = true;
      }
    }
  }
  setdefault() {
    if (!this.model.CurrencyId) {
      this.lookupservice
        .getLookupbyCode("GNR", "Currency", this.currency.Rial)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.CurrencyId = x.Id;
          this.model.CurrencyCode = x.Code;
          this.model.CurrencyTitle = x.Title;
        });
    }
    if (this.model && this.model.Title) {
      this.formGroup.controls["Code"].disable();
    }
    if (!this.model.CustomerTitles) this.model.CustomerTitles = [];
    if (!this.model.CustomerTitles) this.model.CustomerTitles = [];
    if (this.currentrow && this.model.SendingSalesTitle && typeof this.model.SendingSalesTitle === "string") {
      this.model.SendingSalesTitle = this.model.SendingSalesTitle.split(",");
    }
    if (!this.model.AccessToAllBranches) {
      this.isAccessToAllBranches = true;
    }
  }
  addControl() {
    this.setValue("PhoneNumber", this.model.PhoneNumber);
    this.setValue("EconomicalNumber", this.model.EconomicalNumber);
    this.setValue("PostalCode", this.model.PostalCode);
    this.setValue("CustomerTitles", this.model.CustomerTitles);
    this.setValue("TaxPercentage", this.model.TaxPercentage);
    this.setValue("TollPercentage", this.model.TollPercentage);
    this.setValue("ServicePercentage", this.model.ServicePercentage);
    this.setValue("StandardDelayTimeForPreparation", this.model.StandardDelayTimeForPreparation);
    this.setValue("AlertDelayTimeForPreparation", this.model.AlertDelayTimeForPreparation);
    this.setValue("TimeForChangeDate", this.model.TimeForChange);
    this.setValue("AddSettlementForUnpaidAndSuspendedInvoices", this.model.AddSettlementForUnpaidAndSuspendedInvoices);
    this.setValue("RoundingAmount", this.model.RoundingAmount);
    this.setValue("RoundingTypeId", this.model.RoundingTypeId);
    this.setValue("ShippingCostReducedKindId", this.model.ShippingCostReducedKindId);
    this.setValue("Message", this.model.Message);
    this.setValue("DisplayLogoInPrintTemplates", this.model.DisplayLogoInPrintTemplates);
    this.setValue("DisplayAddressInInvoice", this.model.DisplayAddressInInvoice);
    this.setValue("IgnoreBlackBackground", this.model.IgnoreBlackBackground);
    this.setValue("ShowTotalCalories", this.model.ShowTotalCalories);
    this.setValue("CurrencyId", this.model.CurrencyId);
    this.setValue("EnableCreateCustomerSms", this.model.EnableCreateCustomerSms);
    this.setValue("EnableAssignToDriverSms", this.model.EnableAssignToDriverSms);
    this.setValue("HasOrderOnline", this.model.HasOrderOnline);
    this.setValue("ReadyToReceiveOnlineOrders", this.model.ReadyToReceiveOnlineOrders);
    this.setValue("AutoPrintOnline", this.model.AutoPrintOnline);
    this.setValue("CustomerPrintOrderOnile", this.model.CustomerPrintOrderOnile);
    this.setValue("HasDecimal", this.model.HasDecimal);
    this.setValue("HasLocalService", this.model.HasLocalService);
    this.setValue("HasAuditorInSalesAmounts", this.model.HasAuditorInSalesAmounts);
    this.setValue("SendVoucherFromCenter", this.model.SendVoucherFromCenter);
    this.setValue("LocalServiceIp", this.model.LocalServiceIp);
    this.setValue("AutoPrintCash", this.model.AutoPrintCash);
    this.setValue("NationalCode", this.model.NationalCode);
    this.setValue("PaymentType", this.model.PaymentType);
    this.setValue("multiOrder", this.model.multiOrder);
    const currentInformation = this.accountService.authService.currentInformation();
    this.setValue("SmsAdvertisingNumber", currentInformation.SmsAdvertisingNumber);
    this.setValue("SmsServiceNumber", currentInformation.SmsServiceNumber);

    if (!this.model.HasOrderOnline) {
      this.formGroup.controls["PaymentType"].disable();
      this.formGroup.controls["AutoPrintCash"].disable();
      this.formGroup.controls["AutoPrintOnline"].disable();
      this.formGroup.controls["CustomerPrintOrderOnile"].disable();
    } else {
      this.formGroup.controls["PaymentType"].enable();
      this.formGroup.controls["AutoPrintCash"].enable();
      this.formGroup.controls["AutoPrintOnline"].enable();
      this.formGroup.controls["CustomerPrintOrderOnile"].enable();
    }
    this.setValue("IsActive", this.model.IsActive != null ? this.model.IsActive : true);
    this.setValue("HasAccounting", this.model.HasAccounting);
    this.setValue("DetailLedgerId", this.model.DetailLedgerId);
    this.setValue("TransferDebtorsTypeId", this.model.TransferDebtorsTypeId);
    this.setValue("DebtorsSubLedgerId", this.model.DebtorsSubLedgerId);
    this.setValue("SendingSalesTypeId", this.model.SendingSalesTypeId);
    this.setValue("SendingSalesTitle", this.model.SendingSalesTitle);
    this.setValue("NoDisplayDashboard", this.model.NoDisplayDashboard);
    this.setValue("Latitude", this.model.Latitude);
    this.setValue("Longitude", this.model.Longitude);
    this.setValue("InvWarehouseId", this.model.InvWarehouseId);
    this.setValue("InvDailyBalanceInhibitorId", this.model.InvDailyBalanceInhibitorId);
    this.hasLocal = this.model?.HasLocalService;
    this.hasAccounting = this.model?.HasAccounting;

    this.SendingSalesType = this.model?.SendingSalesTypeCode === TypeOfDocument.Separation;
    this.TransferDebtorsType = this.model?.TransferDebtorsTypeCode === TypeOfDocument.accumulative;

    this.cd.markForCheck();
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.BranchDataTransferInfos = undefined;
    this.roundingType = undefined;
    this.shippingCostReducedKind = undefined;
    this.currency = undefined;
    this.inputEditorform = undefined;
  }

  onHasOrderOnline(value: boolean): void {
    if (!value) {
      this.formGroup.controls["PaymentType"].disable();
      this.formGroup.controls["PaymentType"].setValue(null);
      this.formGroup.controls["AutoPrintCash"].disable();
      this.formGroup.controls["AutoPrintOnline"].disable();
      this.formGroup.controls["CustomerPrintOrderOnile"].disable();
      this.formGroup.controls["ReadyToReceiveOnlineOrders"].setValue(false);
      this.formGroup.controls["ReadyToReceiveOnlineOrders"].disable();
    } else {
      this.formGroup.controls["PaymentType"].enable();
      this.formGroup.controls["AutoPrintCash"].enable();
      this.formGroup.controls["AutoPrintOnline"].enable();
      this.formGroup.controls["CustomerPrintOrderOnile"].enable();
      this.formGroup.controls["ReadyToReceiveOnlineOrders"].enable();
    }
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.BranchDataTransferInfos = this.getDetailControlModels("BranchDataTransferInfos");

    const currentInformation = this.accountService.authService.currentInformation();
    if (!currentInformation.RestaurantCallCenter || this.accountService.getCurrentUser().UserName !== "SepidzUser") {
      this.orignalColumns.find((x) => x.name === "BranchAddress").formVisible = false;
    }
    if (!currentInformation.RestaurantCallCenter) {
      this.orignalColumns.find((x) => x.name === "BranchAddress").formVisible = false;
    }
    if (!this.currentrow?.Id) {
      if (currentInformation.RestaurantCallCenter || currentInformation.BranchingAdvancedEnabled || currentInformation.BranchingLightEnabled) {
        this.orignalColumns.find((x) => x.name === "StencilBranchId").formVisible = true;
      }
      this.columns = this.orignalColumns.filter(
        (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
      );
      this.cd.markForCheck();
    }
  }
  setMaxCode() {
    this.httpCommonService
      .get(this.apiName + "/GetMaxCodeBranch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <Branch>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setFormGroup(this.model);
      });

    this.setdefault();
  }

  checkAccounting($event): void {
    this.hasAccounting = $event;
  }
  TransferDebtorsTypeChange(id: number): void {
    const selected = this.AggregateAndSeparateData.find((x) => x.Id === id);
    if (selected) {
      this.TransferDebtorsType = selected.Code && selected.Code === TypeOfDocument.accumulative ? true : false;
      this.formGroup.controls["DebtorsSubLedgerId"].setValue(null);
    }
  }

  SendingSalesTypeChange(id: number): void {
    const selected = this.AggregateAndSeparateData.find((x) => x.Id === id);
    if (selected) {
      this.SendingSalesType = selected.Code && selected.Code === TypeOfDocument.Separation ? true : false;
      this.formGroup.controls["SendingSalesTitle"].setValue(null);
    }
  }

  protected getDataFromFormGroup(): Branch {
    Object.keys(this.formGroup.controls).forEach((key) => {
      if (
        key === "CustomerTitles" &&
        this.formGroup.controls[key] &&
        this.formGroup.controls[key].value &&
        this.formGroup.controls[key].value !== "" &&
        this.formGroup.controls[key].value
      ) {
        this.model[key] = [];
        if (Array.isArray(this.formGroup.controls[key].value)) {
          let k: string[] = this.formGroup.controls[key].value;
          k.forEach((x) => {
            this.model[key].push(x);
          });
        } else this.model[key].push(this.formGroup.controls[key].value);
      } else this.model[key] = this.formGroup.controls[key].value;
    });
    return this.model;
  }
  onCreate() {
    if (this.model.BranchDataTransferInfos === undefined) this.model.BranchDataTransferInfos = [];
    let bdti = <BranchDataTransferInfo>{};
    bdti.BranchId = this.model.Id;
    bdti.InterruptTime = 10;
    bdti.IsCentralOffice = true;
    bdti.TopRecordCount = 100;
    bdti.IsCentralOffice = true;
    bdti.TransferAccountingCode = false;
    bdti.State = RowState.New;
    this.inputEditorform = BranchDataTransferInfoComponent;
    this.dialogService
      .open(this.inputEditorform, {
        currentrow: bdti,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((_model: BranchDataTransferInfo) => {
        if (_model != undefined) {
          if (this.model.BranchDataTransferInfos.some((x) => x.OppositeBranchId === _model.OppositeBranchId))
            this.sts.showDialog(this.translate("ClientApp.GNR.Branch.BranchAlreadySelected"), this.translate("ClientApp.GNR.Branch.SaveInfo"));
          else this.model.BranchDataTransferInfos.push(_model);
          if (_model.Number) this.model.Number = _model.Number;
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
        }
      });
  }
  onEdit(event: BranchDataTransferInfo) {
    this.inputEditorform = BranchDataTransferInfoComponent;
    this.dialogService
      .open(this.inputEditorform, {
        currentrow: event,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((_model: BranchDataTransferInfo) => {
        if (_model != undefined) {
          let temp = this.model.BranchDataTransferInfos.find((x) => x.OppositeBranchId == _model.OrignalOppositeBranchId);
          temp.OppositeBranchUrl = _model.OppositeBranchUrl;
          temp.OppositeBranchId = _model.OppositeBranchId;
          temp.OppositeBranchTitle = _model.OppositeBranchTitle;
          temp.StartHour1 = _model.StartHour1;
          temp.EndHour1 = _model.EndHour1;
          temp.StartHour2 = _model.StartHour2;
          temp.EndHour2 = _model.EndHour2;
          temp.StartHour3 = _model.StartHour3;
          temp.EndHour3 = _model.EndHour3;
          temp.InterruptTime = _model.InterruptTime;
          temp.IsCentralOffice = _model.IsCentralOffice;
          temp.TransferAccountingCode = _model.TransferAccountingCode;
          temp.TopRecordCount = _model.TopRecordCount;
          temp.State = _model.State;
          if (_model.Number) {
            this.model.Number = _model.Number;
            this.setValue("Number", this.model.Number);
          }
        }
        this.tabsservice.tabItemonRefreshData.next(this.apiName);
      });
  }
  onDelete(event: BranchDataTransferInfo) {
    let message = `${this.translate("ClientApp.GNR.Branch.AreSureToDelete")}`;
    this.sts.showDialog(message, this.translate("ClientApp.GNR.Branch.DeleteInfo"), DialogType.confirm, () => this.deleteFormHelper(event));
  }
  deleteFormHelper(dataItem: BranchDataTransferInfo) {
    let entity = this.model.BranchDataTransferInfos.find((x) => x.OppositeBranchId === dataItem.OppositeBranchId);
    if (entity != undefined) {
      if (entity.State === RowState.New) entity.State = RowState.Detached;
      else entity.State = RowState.Delete;
      this.tabsservice.tabItemonRefreshData.next(this.apiName);
    }
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  ngAfterViewInit(): void {
    this.FillData();
  }

  public getSaleMethodBranchOnlineOrder() {
    this.httpCommonService
      .get("SaleMethodBranch/GetAllSaleMethodBranch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: SaleMethodBranchModel[]) => {
        const branchId = this.model.Id;
        this.isAccessToActivation = data.some((x) => x.HasDelino && branchId && x.BranchId === branchId);
        this.CheckHasOrderOnline();
      });
  }
  isValid() {
    const controls = this.formGroup.controls;
    if (controls["HasOrderOnline"].value && !controls["PaymentType"].value && !this.isMultiBranch) {
      this.sts.showDialog(this.translate("ClientApp.GNR.Branch.ChooseOnlineInvoicePayment"), this.translate("ClientApp.GNR.Branch.Attention"));
      return false;
    }
    if (controls["HasAccounting"].value && this.AggregateAndSeparateData?.length) {
      const selected = this.AggregateAndSeparateData.find((x) => x.Id === controls["TransferDebtorsTypeId"].value);
      if (selected?.Code === TypeOfDocument.accumulative && !controls["DebtorsSubLedgerId"]?.value) {
        this.sts.showDialog(this.translate("ClientApp.GNR.Branch.SelectDetailLedger"), this.translate("ClientApp.GNR.Branch.Attention"));
        return false;
      }
    }
    if (!controls["IsActive"].value && !this.isMultiBranch) {
      this.sts.showDialog(this.translate("ClientApp.GNR.Branch.SingleBranchSoftware"), this.translate("ClientApp.GNR.Branch.Attention"));
      return false;
    }
    const value = controls["ReadyToReceiveOnlineOrders"].value;
    if (typeof value === "boolean" && this.hasOrderOnline) {
      if (this.isAccessToActivation) {
        const branchId = this.model.Id;
        const isActive = value;
        this.httpCommonService
          .get(`Delino/ActivationInDelino/${isActive}/${branchId}`)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res: boolean) => {
            console.log(res);
          });
      } else if (value) {
        this.sts.showDialog(this.translate("ClientApp.GNR.Branch.ReceiveOnlineOrderMustSale"), "");
        return false;
      }
    }

    if (!controls["LocalServiceIp"].value && controls["HasLocalService"].value) {
      this.sts.showDialog(this.translate("ClientApp.GNR.Branch.LocalServiceIsMandatory"), "");
      return false;
    }
    return super.isValid();
  }

  beforupdate(): void {
    const sendingSalesTitleCTRL = this.formGroup.controls["SendingSalesTitle"];
    if (sendingSalesTitleCTRL?.value) sendingSalesTitleCTRL.setValue(sendingSalesTitleCTRL.value.join());
  }

  showLocal(event) {
    if (!event) this.formGroup.controls["LocalServiceIp"].setValue("");
    this.hasLocal = event;
  }

  showFleetService(event: boolean) {
    this.hasFleetService = event;
    if (!event) {
      this.formGroup.get("Longitude")?.setValue("");
      this.formGroup.get("Latitude")?.setValue("");
      this.formGroup.get("Longitude")?.disable();
      this.formGroup.get("Latitude")?.disable();
    } else {
      this.formGroup.get("Longitude")?.enable();
      this.formGroup.get("Latitude")?.enable();
    }
  }
  ConnectionTest() {
    try {
      this.splashScreenService.startLoading();
      this.splashFormService.openDialog();
      if (!this.formGroup.controls["LocalServiceIp"].value) {
        this.splashScreenService.stopLoading();
        this.splashFormService.closeLoading();
        return;
      }
      const url = "http://" + this.formGroup.controls["LocalServiceIp"].value + "/TestConnection";
      this.http
        .get(url, { headers: { "Access-Control-Allow-Headers": "Content-Type", "Access-Control-Allow-Origin": "*" } })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: any) => {
            if (data) {
              this.sts.showDialog(this.translate("ClientApp.GNR.Branch.ConnectSuccessfully"), this.translate("ClientApp.GNR.Branch.Attention"));
              this.splashScreenService.stopLoading();
              this.splashFormService.closeLoading();
            }
          },
          (err) => {
            this.sts.showDialog(
              `${this.translate("ClientApp.GNR.Branch.ConnectionProblem")} ` + err,
              this.translate("ClientApp.GNR.Branch.Attention")
            );
            this.splashScreenService.stopLoading();
            this.splashFormService.closeLoading();
            console.log(err);
          }
        );
      // this.httpCommonService
      //   .getCustom(url)
      //   .pipe(takeUntil(this.ngUnsubscribe))
      //   .subscribe(
      //     (data: any) => {
      //       if (data) {
      //         this.sts.showDialog(this.translate("ClientApp.GNR.Branch.ConnectSuccessfully"), this.translate("ClientApp.GNR.Branch.Attention"));
      //         this.splashScreenService.stopLoading();
      //         this.splashFormService.closeLoading();
      //       }
      //     },
      //     (err) => {
      //       this.sts.showDialog(
      //         `${this.translate("ClientApp.GNR.Branch.ConnectionProblem")} ` + err,
      //         this.translate("ClientApp.GNR.Branch.Attention")
      //       );
      //       this.splashScreenService.stopLoading();
      //       this.splashFormService.closeLoading();
      //       console.log(err);
      //     }
      //   );
    } catch (e) {
      this.sts.showDialog(`${this.translate("ClientApp.GNR.Branch.ConnectionProblem")} ` + e, this.translate("ClientApp.GNR.Branch.Attention"));
      console.log(e);
      this.splashScreenService.stopLoading();
      this.splashFormService.closeLoading();
    }
  }
  afterupdate() {
    this.accountService.authService.getBranchById(this.accountService.authService.currentBranchId);
  }
  valueChangeByApiName(event: { KeyName: string; apiName: string; data: any }) {
    if (event?.KeyName === "StencilBranchId" && event?.data) {
      this.setValue("TaxPercentage", event.data.TaxPercentage);
      this.setValue("TollPercentage", event.data.TollPercentage);
      this.setValue("ServicePercentage", event.data.ServicePercentage);
      this.setValue("RoundingTypeId", event.data.RoundingTypeId);
      this.setValue("ShippingCostReducedKindId", event.data.ShippingCostReducedKindId);
      this.setValue("CustomerTitles", event.data.CustomerTitles);
      this.setValue("SendingSalesTypeId", event.data.SendingSalesTypeId);
      this.setValue("TransferDebtorsTypeId", event.data.TransferDebtorsTypeId);
      this.setValue("DetailLedgerId", event.data.DetailLedgerId);
      this.setValue("InvWarehouseId", event.data.InvWarehouseId);
    }

    this.httpCommonService
      .getItem("Branch", event?.data?.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((branch: Branch) => {
        if (event?.KeyName === "StencilBranchId" && branch) {
          this.setValue("CustomerTitles", branch.CustomerTitles);
          this.setValue("TaxPercentage", branch.TaxPercentage);
          this.setValue("TollPercentage", branch.TollPercentage);
          this.setValue("ServicePercentage", branch.ServicePercentage);
          this.setValue("RoundingTypeId", branch.RoundingTypeId);
          this.setValue("ShippingCostReducedKindId", branch.ShippingCostReducedKindId);
          this.setValue("RoundingAmount", branch.RoundingAmount);
          this.setValue("SendingSalesTypeId", branch.SendingSalesTypeId);
          this.setValue("TransferDebtorsTypeId", branch.TransferDebtorsTypeId);
          this.setValue("DetailLedgerId", branch.DetailLedgerId);
          this.setValue("InvWarehouseId", branch.InvWarehouseId);
        }
      });
  }

  onAggregateAndSeparateLoad(data: { apiName: string; data: any[] }) {
    this.AggregateAndSeparateData = data?.data;
  }

  /**
   * انتخاب لوکیشن برای رستوران
   * @param
   */
  showMapDialog() {
    const confirmValue = new Subject();
    confirmValue.pipe(take(1)).subscribe((value: MapConfirmValue) => {
      this.model["Latitude"] = value.lat;
      this.setValue("Latitude", this.model.Latitude);
      this.model["Longitude"] = value.lng;
      this.setValue("Longitude", this.model.Longitude);
    });
    this.dialogService.open(
      MapComponent,
      { confirmValue, lat: this.model.Latitude ?? 0, lng: this.model.Longitude ?? 0 },
      { autoFocus: true, closeOnClickOutside: true }
    );
  }

  enumToArray(enumObj: any): any[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: Number(enumObj[key]), Title: key }));
  }
  enumToEnumModelArray(enumObj: any): EnumModel[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: enumObj[key], Title: key }));
  }

  private CheckHasOrderOnline(): void {
    const url = `Branch/HasOnlineOrderCheck`;
    this.httpCommonService
      .get(url)
      .pipe(take(1))
      .subscribe((result: boolean) => {
        if (result) this.hasOrderOnline = result;
      });
  }
}
